/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { lpInspectionCouponControllerCheck } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-check';
import { LpInspectionCouponControllerCheck$Params } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-check';
import { lpInspectionCouponControllerCreate } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-create';
import { LpInspectionCouponControllerCreate$Params } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-create';
import { lpInspectionCouponControllerCreateWithChild } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-create-with-child';
import { LpInspectionCouponControllerCreateWithChild$Params } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-create-with-child';
import { lpInspectionCouponControllerDelete } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-delete';
import { LpInspectionCouponControllerDelete$Params } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-delete';
import { lpInspectionCouponControllerSearch } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-search';
import { LpInspectionCouponControllerSearch$Params } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-search';
import { lpInspectionCouponControllerUpdate } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-update';
import { LpInspectionCouponControllerUpdate$Params } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-update';
import { lpInspectionCouponControllerUse } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-use';
import { LpInspectionCouponControllerUse$Params } from '../fn/lp-inspection-coupon/lp-inspection-coupon-controller-use';
import { LpInspectionCouponDto } from '../models/lp-inspection-coupon-dto';
import { lpInspectionCouponGroupControllerCreate } from '../fn/lp-inspection-coupon/lp-inspection-coupon-group-controller-create';
import { LpInspectionCouponGroupControllerCreate$Params } from '../fn/lp-inspection-coupon/lp-inspection-coupon-group-controller-create';
import { lpInspectionCouponGroupControllerDelete } from '../fn/lp-inspection-coupon/lp-inspection-coupon-group-controller-delete';
import { LpInspectionCouponGroupControllerDelete$Params } from '../fn/lp-inspection-coupon/lp-inspection-coupon-group-controller-delete';
import { lpInspectionCouponGroupControllerFindById } from '../fn/lp-inspection-coupon/lp-inspection-coupon-group-controller-find-by-id';
import { LpInspectionCouponGroupControllerFindById$Params } from '../fn/lp-inspection-coupon/lp-inspection-coupon-group-controller-find-by-id';
import { lpInspectionCouponGroupControllerSearch } from '../fn/lp-inspection-coupon/lp-inspection-coupon-group-controller-search';
import { LpInspectionCouponGroupControllerSearch$Params } from '../fn/lp-inspection-coupon/lp-inspection-coupon-group-controller-search';
import { lpInspectionCouponGroupControllerUpdate } from '../fn/lp-inspection-coupon/lp-inspection-coupon-group-controller-update';
import { LpInspectionCouponGroupControllerUpdate$Params } from '../fn/lp-inspection-coupon/lp-inspection-coupon-group-controller-update';
import { LpInspectionCouponGroupDto } from '../models/lp-inspection-coupon-group-dto';
import { LpInspectionDto } from '../models/lp-inspection-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class LpInspectionCouponService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `lpInspectionCouponControllerSearch()` */
  static readonly LpInspectionCouponControllerSearchPath = '/api/lp-inspection-coupon/search';

  /**
   * 쿠폰 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionCouponControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionCouponControllerSearch$Response(params: LpInspectionCouponControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return lpInspectionCouponControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionCouponControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionCouponControllerSearch(params: LpInspectionCouponControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.lpInspectionCouponControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionCouponControllerCheck()` */
  static readonly LpInspectionCouponControllerCheckPath = '/api/lp-inspection-coupon/check';

  /**
   * 쿠폰 사용 가능 여부 확인.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionCouponControllerCheck()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionCouponControllerCheck$Response(params: LpInspectionCouponControllerCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponDto>> {
    return lpInspectionCouponControllerCheck(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 사용 가능 여부 확인.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionCouponControllerCheck$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionCouponControllerCheck(params: LpInspectionCouponControllerCheck$Params, context?: HttpContext): Observable<LpInspectionCouponDto> {
    return this.lpInspectionCouponControllerCheck$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionCouponDto>): LpInspectionCouponDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionCouponControllerCreate()` */
  static readonly LpInspectionCouponControllerCreatePath = '/api/lp-inspection-coupon';

  /**
   * 쿠폰 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionCouponControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionCouponControllerCreate$Response(params: LpInspectionCouponControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponDto>> {
    return lpInspectionCouponControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionCouponControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionCouponControllerCreate(params: LpInspectionCouponControllerCreate$Params, context?: HttpContext): Observable<LpInspectionCouponDto> {
    return this.lpInspectionCouponControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionCouponDto>): LpInspectionCouponDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionCouponControllerCreateWithChild()` */
  static readonly LpInspectionCouponControllerCreateWithChildPath = '/api/lp-inspection-coupon/child';

  /**
   * 쿠폰 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionCouponControllerCreateWithChild()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionCouponControllerCreateWithChild$Response(params: LpInspectionCouponControllerCreateWithChild$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponDto>> {
    return lpInspectionCouponControllerCreateWithChild(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionCouponControllerCreateWithChild$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionCouponControllerCreateWithChild(params: LpInspectionCouponControllerCreateWithChild$Params, context?: HttpContext): Observable<LpInspectionCouponDto> {
    return this.lpInspectionCouponControllerCreateWithChild$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionCouponDto>): LpInspectionCouponDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionCouponControllerUse()` */
  static readonly LpInspectionCouponControllerUsePath = '/api/lp-inspection-coupon/use';

  /**
   * 쿠폰 사용.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionCouponControllerUse()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionCouponControllerUse$Response(params: LpInspectionCouponControllerUse$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionDto>> {
    return lpInspectionCouponControllerUse(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 사용.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionCouponControllerUse$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionCouponControllerUse(params: LpInspectionCouponControllerUse$Params, context?: HttpContext): Observable<LpInspectionDto> {
    return this.lpInspectionCouponControllerUse$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionDto>): LpInspectionDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionCouponControllerDelete()` */
  static readonly LpInspectionCouponControllerDeletePath = '/api/lp-inspection-coupon/{id}';

  /**
   * 쿠폰 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionCouponControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionCouponControllerDelete$Response(params: LpInspectionCouponControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponDto>> {
    return lpInspectionCouponControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionCouponControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionCouponControllerDelete(params: LpInspectionCouponControllerDelete$Params, context?: HttpContext): Observable<LpInspectionCouponDto> {
    return this.lpInspectionCouponControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionCouponDto>): LpInspectionCouponDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionCouponControllerUpdate()` */
  static readonly LpInspectionCouponControllerUpdatePath = '/api/lp-inspection-coupon/{id}';

  /**
   * 쿠폰 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionCouponControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionCouponControllerUpdate$Response(params: LpInspectionCouponControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponDto>> {
    return lpInspectionCouponControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionCouponControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionCouponControllerUpdate(params: LpInspectionCouponControllerUpdate$Params, context?: HttpContext): Observable<LpInspectionCouponDto> {
    return this.lpInspectionCouponControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionCouponDto>): LpInspectionCouponDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionCouponGroupControllerSearch()` */
  static readonly LpInspectionCouponGroupControllerSearchPath = '/api/lp-inspection-coupon-group/search';

  /**
   * 쿠폰 그룹 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionCouponGroupControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionCouponGroupControllerSearch$Response(params: LpInspectionCouponGroupControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return lpInspectionCouponGroupControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 그룹 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionCouponGroupControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionCouponGroupControllerSearch(params: LpInspectionCouponGroupControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.lpInspectionCouponGroupControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionCouponGroupControllerFindById()` */
  static readonly LpInspectionCouponGroupControllerFindByIdPath = '/api/lp-inspection-coupon-group/{id}';

  /**
   * 쿠폰 그룹 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionCouponGroupControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionCouponGroupControllerFindById$Response(params: LpInspectionCouponGroupControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponGroupDto>> {
    return lpInspectionCouponGroupControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 그룹 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionCouponGroupControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionCouponGroupControllerFindById(params: LpInspectionCouponGroupControllerFindById$Params, context?: HttpContext): Observable<LpInspectionCouponGroupDto> {
    return this.lpInspectionCouponGroupControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionCouponGroupDto>): LpInspectionCouponGroupDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionCouponGroupControllerDelete()` */
  static readonly LpInspectionCouponGroupControllerDeletePath = '/api/lp-inspection-coupon-group/{id}';

  /**
   * 쿠폰 그룹 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionCouponGroupControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionCouponGroupControllerDelete$Response(params: LpInspectionCouponGroupControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return lpInspectionCouponGroupControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 그룹 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionCouponGroupControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionCouponGroupControllerDelete(params: LpInspectionCouponGroupControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    return this.lpInspectionCouponGroupControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `lpInspectionCouponGroupControllerUpdate()` */
  static readonly LpInspectionCouponGroupControllerUpdatePath = '/api/lp-inspection-coupon-group/{id}';

  /**
   * 쿠폰 그룹 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionCouponGroupControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionCouponGroupControllerUpdate$Response(params: LpInspectionCouponGroupControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponGroupDto>> {
    return lpInspectionCouponGroupControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 그룹 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionCouponGroupControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionCouponGroupControllerUpdate(params: LpInspectionCouponGroupControllerUpdate$Params, context?: HttpContext): Observable<LpInspectionCouponGroupDto> {
    return this.lpInspectionCouponGroupControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionCouponGroupDto>): LpInspectionCouponGroupDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionCouponGroupControllerCreate()` */
  static readonly LpInspectionCouponGroupControllerCreatePath = '/api/lp-inspection-coupon-group';

  /**
   * 쿠폰 그룹 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionCouponGroupControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionCouponGroupControllerCreate$Response(params: LpInspectionCouponGroupControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponGroupDto>> {
    return lpInspectionCouponGroupControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 그룹 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionCouponGroupControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionCouponGroupControllerCreate(params: LpInspectionCouponGroupControllerCreate$Params, context?: HttpContext): Observable<LpInspectionCouponGroupDto> {
    return this.lpInspectionCouponGroupControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionCouponGroupDto>): LpInspectionCouponGroupDto => r.body)
    );
  }

}
